export default "__VITE_ASSET__Dgr$t8ju__"